import { Action, createReducer, on } from "@ngrx/store";
import * as PumpUnitActions from "./pump-unit.actions";

export const pumpUnitFeatureKey = 'pumpUnit';

export interface PumpUnitState {
  item: string;
  packaging: string;
  maxTemp: string;
  suctionHead: string;
  picture: string;
  drawing: string;
  drawing_url?: string;
  picture_url?: string;
}

export const initialState: PumpUnitState = {
  item: '',
  packaging: '',
  maxTemp: '',
  suctionHead: '',
  picture: '',
  drawing: '',
}

const reducer = createReducer(
  initialState,
  on(PumpUnitActions.setPumpUnitItem, (state, action) => {
    return {
      ...state,
      item: action.data
    }
  }),
  on(PumpUnitActions.setPumpUnitPackaging, (state, action) => {
    return {
      ...state,
      packaging: action.data
    }
  }),
  on(PumpUnitActions.setPumpUnitMaxTemp, (state, action) => {
    return {
      ...state,
      maxTemp: action.data
    }
  }),
  on(PumpUnitActions.setPumpUnitSuctionHead, (state, action) => {
    return {
      ...state,
      suctionHead: action.data
    }
  }),
  on(PumpUnitActions.setPumpUnitPicture, (state, action) => {
    return {
      ...state,
      picture: action.data
    }
  }),
  on(PumpUnitActions.setPumpUnitDrawing, (state, action) => {
    return {
      ...state,
      drawing: action.data
    }
  }),
  on(PumpUnitActions.setPumpUnitPictureUrl, (state, action) => {
    return {
      ...state,
      picture_url: action.data
    }
  }),
  on(PumpUnitActions.setPumpUnitDrawingUrl, (state, action) => {
    return {
      ...state,
      drawing_url: action.data
    }
  })

);

export function pumpUnitReducer(
  state: PumpUnitState,
  action: Action
): PumpUnitState {
  return reducer(state, action);
}
